import { Component, OnInit, Input } from '@angular/core';
import { DataService, MIN_CHAR_SEARCH_LENGTH, AuthService, DateUtility } from '../shared';
import { ActivatedRoute, Router, NavigationEnd, RoutesRecognized } from '@angular/router';
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';

@Component({
  selector: 'jhi-inner-nav',
  templateUrl: './inner-nav.component.html',
  styleUrls: ['./inner-nav.component.scss']
})
export class InnerNavComponent implements OnInit {
  role: Boolean = false;
  show: Boolean;
  isWorker: Boolean;
  innerDisable = true;
  @Input() Welcome;

  constructor(private dataService: DataService, private authService: AuthService, private router: Router,
    private modalService: ModalPopupService) { }

  ngOnInit() {
    setTimeout(() => {
      console.log(this.dataService.getSharedDataObject().get("roles"));
      if (this.dataService.getSharedDataObject().get("roles")[0].id === 4) {
        this.role = true;
      }
      else {
        this.role = false;
      }
    }, 3000);
    if ((this.router.url === '/reset' && (this.dataService.getSharedDataObject().get("tempPasswordSw") === 'Y' || this.dataService.getSharedDataObject().get("expirationSw"))) || this.router.url === '/forgotPassword') {
      this.innerDisable = false;
    }
    if(this.dataService.getSharedDataObject().get('ISWORKERPORTAL') === true){
      this.isWorker = false;
    }
    else{
      this.isWorker = true;
    }
  }
  processSignOut() {
    this.router.navigate(['redirect']);
    this.modalService.logOut = true;
    setTimeout(() => {
      if (this.modalService.test === false) {
        const isworkerPortal = this.dataService.getSharedDataObject().get('ISWORKERPORTAL');
        this.dataService.sharedDataMap = new Map<string, any>();
        this.authService.signOut();
        if (isworkerPortal) {
          this.router.navigate(['SNAPWorks/workerportal']);
        } else {
          this.router.navigate(['SNAPWorks/providerportal']);
        }
      } else {
        console.log(this.modalService.getResult());
      }
    }, 0);
  }

  processReset() {
    this.router.navigate(['reset']);
  }
  onClickedOutside(e: Event) {
    if (this.show == true) {
      this.show = false;
    }
  }

  onKeyDown(e: KeyboardEvent) {

    if (e.keyCode === 32) {
      e.preventDefault();
      const target: any = e.target;
      if (target.id === 'navbarResponsive') {
        if (this.show) {
          this.show = false;
        } else {
          this.show = true;
        }
      } else if (target.id === 'reset') {
        this.processReset();
      } else {
        this.processSignOut();
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/inner-nav/inner-nav.component.ts